import { z } from 'zod';

export const stratumnErrorSchema = z.object({
  service: z.string(),
  extra: z.record(z.any()),
  uniqueCode: z.string(),
  _message: z.string(),
  statusCode: z.string()
});

export type StratumnError = z.infer<typeof stratumnErrorSchema>;
